import { fileQueryPollInterval } from '../../configs/poll-interval';
import { FileDetailsFileFragment, FileStatus } from '../../graphql/generated';
import {
  PollConfigCondition,
  useDynamicPolling,
} from '../use-dynamic-polling/use-dynamic-polling';

type UseEnableDynamicFilePolling = {
  startPolling: (interval: number) => void;
  stopPolling: () => void;
  data?: FileDetailsFileFragment['status'];
};

export const generateFilePollingConditions = (
  data?: FileDetailsFileFragment['status']
): PollConfigCondition[] => [
  {
    condition: data === FileStatus.AWAITING_UPLOAD,
    interval: fileQueryPollInterval.ONE_SECOND,
  },
  {
    condition: data === FileStatus.PROCESSING,
    interval: fileQueryPollInterval.FIVE_SECONDS,
  },
];

export const useEnableDynamicFilePolling = ({
  stopPolling,
  startPolling,
  data,
}: UseEnableDynamicFilePolling): void => {
  const pollConfig = {
    defaultInterval: fileQueryPollInterval.DEFAULT,
    conditions: generateFilePollingConditions(data),
  };

  useDynamicPolling({ startPolling, stopPolling, pollConfig });
};
